// FilterArticles.jsx
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ButtonClose, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import ModalCsv from '../Modal/ModalRules/ModalRublesTable/ModalCsv';
import './FilterArticles.scss';
import { TextPage } from '../TextPage/TextPage';

const FilterArticles = ({
    filterValue = [], 
    setFilterValue,
    initialValue = undefined
}) => {
    const [initialFilterValue, setInitialFilterValue] = useState(initialValue || []);
    const [isModalFilter, setIsModalFilter] = useState(false);
    const [portalContainer, setPortalContainer] = useState(null);

    // Создаем или находим контейнер для портала
    useEffect(() => {
        let container = document.getElementById('modal-portal-root');
        if (!container) {
            container = document.createElement('div');
            container.id = 'modal-portal-root';
            document.body.appendChild(container);
        }
        setPortalContainer(container);

        return () => {
            // Очищаем контейнер, если он пуст и модалка закрыта
            if (container && container.children.length === 0 && !isModalFilter) {
                document.body.removeChild(container);
            }
        };
    }, []);

    // Обработчик закрытия модалки
    const handleCloseModal = () => {
        setIsModalFilter(false);
    };

    // Обработчик установки фильтра
    const handleSetFilterValue = (newValue) => {
        setFilterValue(newValue);
        setIsModalFilter(false);
    };

    return (
        <>
            {/* Рендерим модалку через портал */}
            {isModalFilter && portalContainer && createPortal(
                <ModalCsv
                    setIsModal={handleCloseModal}
                    initialFilterValue={initialFilterValue}
                    setFilterValue={handleSetFilterValue}
                />,
                portalContainer
            )}

            <ButtonBasic
                whiteGreen
                width="auto"
                text="Фильтр по артикулу"
                size="32px"
                onClick={() => setIsModalFilter(true)}
            />

            {filterValue?.length ? (
                <>
                    <TextPage
                        style={{
                            fontSize: '12px'
                        }}
                        text={
                            <>
                                Фильтр по артикулам:{' '}
                                <span
                                    style={{
                                        color: '#3900B1',
                                        fontWeight: 700
                                    }}
                                >
                                    {filterValue.length > 6 ? (
                                        <>
                                            {filterValue.slice(0, 6).map((el, ind) => (
                                                <span key={ind}>
                                                    {el}
                                                    {ind !== 5 ? ', ' : ''}
                                                </span>
                                            ))}
                                            ...
                                        </>
                                    ) : (
                                        filterValue.map((el, ind) => (
                                            <span key={ind}>
                                                {el}
                                                {filterValue.length - 1 !== ind ? ', ' : ''}
                                            </span>
                                        ))
                                    )}
                                </span>
                            </>
                        }
                    />
                    <ButtonClose
                        s
                        onClick={() => setFilterValue([])}
                    />
                </>
            ) : null}
        </>
    );
};

export { FilterArticles };